export class Coord {
  constructor(obj) {
    this.lat = obj.latitude || obj.lat;
    this.lng = obj.longitude || obj.lng;
  }
}
